export default __webpack_public_path__ + "static/media/regulatory--no-overtaking-atvs--g1.6dd58589.png";